import { render, staticRenderFns } from "./BCXDatePickerYears.vue?vue&type=template&id=0c0a4bd6"
import script from "./BCXDatePickerYears.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXDatePickerYears.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BCXDatePickerYears.vue?vue&type=style&index=0&id=0c0a4bd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports